import * as React from 'react';
import { Container, TituloSecao } from './styles';
import Grid from '../../componentes/Grid';
import { useParams } from 'react-router-dom';
import userContext from '../../Context/UserContext';
import { useContext } from 'react';
import { FormatarUrlName } from '../../helpers/valores';

const Grupo: React.FC = () => {
  const { id, name, filtro }: any = useParams();
  const currentlyUser = useContext(userContext);
  const { Codcliente, Codempresacli } = currentlyUser.user;
   const nomeFormatado = FormatarUrlName(decodeURIComponent(name));

  return (
    <Container>
      <TituloSecao>
        Grupo {id} - {nomeFormatado}
      </TituloSecao>
      {filtro == "maisvendidos" ?
        <Grid Titulo={"Grupo" + nomeFormatado} MaisVendidos={1} Grupo={id} Codcliente={Codcliente} Codempresacli={Codempresacli} /> :
        filtro == "lancamentos" ?
          <Grid Titulo={"Grupo" + nomeFormatado} Lancamento={1} Grupo={id} Codcliente={Codcliente} Codempresacli={Codempresacli} /> :
          <Grid Titulo={"Grupo" + nomeFormatado} Grupo={id} Codcliente={Codcliente} Codempresacli={Codempresacli} />
      }

    </Container>
  )
};

export default Grupo;
